<template>
  <DialogTemplate>
    <div class="rlsdialog px-2">
      <GwVideoPlayer
        class="rlsdialog_videocont mt-4"
        type="youtube"
        :src="'jS48TUpNs_U'"
      />
      <div class="mt-4 clr-grey f-column text-centere">
        <div class="text-large weight_500 mt-2 clr-white text-center">
          <b> Introducing Heads Up Preflop AI! </b>
        </div>
        <div class="mt-4 clr-grey text-center">
          Now you can solve optimal preflop strategies for heads up games - with customized betting
          trees, stack depths, and antes. This includes all the features of GTO Wizard AI, such as
          our dynamic sizing, nodelocking, and custom parameters.
        </div>
      </div>
      <div
        class="mt-4 f-center f-column"
        @click="setSol()"
      >
        <div
          class="gw_btn gw_btn_large gw_btn_primary weight_600 clr-white text-semi-large mt-4"
          style="height: 3rem"
        >
          Try Preflop AI Solving now!
        </div>

        <LinkGuide
          class="ml-auto px-4 py-2 mx-auto mt-2"
          :link="links_url_links.preflop_ai.url"
          style="--gwlinkguide-font-size: 1rem"
          :text="'Read more about HU Preflop AI'"
          @click.stop
        />
      </div>
    </div>
  </DialogTemplate>
</template>

<script>
import { nextTick } from 'vue'
import DialogTemplate from '@/components/Dialogs/DialogTemplate'
import LinkGuide from '@/components/AppBar/LinkGuide'
import links_mix from '@/mixins/links_mix'
import GwVideoPlayer from '@/components/lib/GwVideoPlayer'

export default {
  name: 'RlsDialog',
  components: {
    DialogTemplate,
    LinkGuide,
    GwVideoPlayer,
  },
  mixins: [links_mix],
  data() {
    return {}
  },
  methods: {
    setSol() {
      const id = this.isDev
        ? '61d7afa2-8422-4542-b289-d734233b9328'
        : '877ee355-349a-4000-8e9b-b06d340c4943'
      // if (this.$route.query.cussol_id === id && this.$route.query.solution_type === 'custom') return

      this.$store.dispatch('sol_resetCustomSol', {
        item: {
          id,
        },
      })

      nextTick(() => {
        this.openCustomSolutionsDialog()
      })
    },
    // close() {
    // this.$store.dispatch('router_rm_dialog', 'rls-dialog')
    // },
    openCustomSolutionsDialog() {
      // eslint-disable-next-line no-console
      console.warn('Refactor opening of custom soltion dialog')
      // const tmpNamespace = 'tmp/primary'
      // let dialog = 'solfigr-create-custom-solution-dialog'
      // dialog = `${dialog}_namespace-${tmpNamespace}`
      // TODO Vue3 do this two things in one action
      // this.$store.dispatch('router_set_dialogs', dialog)
      // this.$store.dispatch('router_rm_dialog', 'rls-dialog')
    },
  },
  computed: {
    isDev() {
      return import.meta.env.VITE_ENV !== 'production'
    },
  },
}
</script>

<style lang="scss" scoped>
.rlsdialog {
  display: flex;
  flex-direction: column;
  width: clamp(1px, 32rem, 100vw);
  max-width: 100%;
  padding: 0 0 2rem 0;
  &_videocont {
    width: 100%;
    aspect-ratio: 16 / 9;
    overflow: hidden;
    border-radius: 16px;
  }
}
</style>
